$('.single-item').slick({
    dots: true,
    arrows: false,
//   slidesToShow: 1,
//   adaptiveHeight: true
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    // fade: true,
    cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
    pauseOnFocus: false, 
    pauseOnHover: false
    
});

